<script lang="ts">
	export let color = '#9B9B9B';
	export let size = '18';
</script>

<svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M8.23068 5L3.99991 9L8.23068 13"
		stroke={color}
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path d="M14 9H4.76923" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
</svg>
